import React, { useState, useEffect } from "react";
// import { useNavigate } from 'react-router-dom';
import { Header } from "../../components/Header/Header";
// import Jogo from '../../../models/Jogo';
import {
  getDadosJogo,
  getJogadores,
  saveTime1,
  saveTime2,
  saveProxReservas,
  clearProxReservas,
  clearTime1,
  clearTime2,
  clearGoleiros,
} from "../../../db/db";
import "./PreJogo.css";
import { useNavigate } from "react-router-dom";
import { Footer } from "../../components/Footer/Footer";

const PreJogo = () => {
  const [jogo, setJogo] = useState([]);
  const [jogadores, setJogadores] = useState([]);
  const [time1, setTime1] = useState([]);
  const [time2, setTime2] = useState([]);
  const [ordenacaoSelecionada, setOrdenacaoSelecionada] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchJogo = async () => {
      try {
        const dadosJogo = await getDadosJogo();
        if (dadosJogo.length > 0) {
          setJogo(dadosJogo[0]); // Como sempre será 1 jogo, pegamos o primeiro (ou único)
        } else {
          console.log("Nenhum jogo encontrado.");
        }
      } catch (error) {
        console.error("Erro ao recuperar o jogo:", error);
      }
    };
    const fetchJogadores = async () => {
      const jogadoresDB = await getJogadores();
      if (jogadoresDB.length > 0) {
        setJogadores(jogadoresDB);
      }
    };
    fetchJogo();
    fetchJogadores();
  }, []);

  const qtdPorTime = jogo?.jogadoresPorTime || 5;
  const minimoJogadores = qtdPorTime * 2;
  const timesPreenchidos =
    time1.length === qtdPorTime && time2.length === qtdPorTime;
  const prontoParaIniciar =
    Boolean(ordenacaoSelecionada) &&
    jogadores.length >= minimoJogadores &&
    timesPreenchidos;

  const getInicial = (nome = "") => {
    if (typeof nome !== "string") return "?";
    return nome.trim().charAt(0).toUpperCase() || "?";
  };

  const criarTimesPorChegada = () => {
    const novoTime1 = [];
    const novoTime2 = [];

    // Alterna os jogadores entre time1 e time2, respeitando o limite de jogadores por time
    jogadores.forEach((jogador, index) => {
      if (index % 2 === 0 && novoTime1.length < qtdPorTime) {
        novoTime1.push(jogador); // Jogadores em índices pares vão para o Time 1
      } else if (novoTime2.length < qtdPorTime) {
        novoTime2.push(jogador); // Jogadores em índices ímpares vão para o Time 2
      }
    });

    // Atualiza os times no estado
    setTime1(novoTime1);
    setTime2(novoTime2);
    setOrdenacaoSelecionada("chegada");
  };

  const criarTimesAleatorios = () => {
    const novoTime1 = [];
    const novoTime2 = [];

    // Faz uma cópia do array de jogadores para embaralhar
    const jogadoresEmbaralhados = [...jogadores];

    // Algoritmo de Fisher-Yates para embaralhar o array
    for (let i = jogadoresEmbaralhados.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [jogadoresEmbaralhados[i], jogadoresEmbaralhados[j]] = [
        jogadoresEmbaralhados[j],
        jogadoresEmbaralhados[i],
      ];
    }

    // Distribui os jogadores embaralhados alternadamente entre time1 e time2, respeitando o limite de jogadores por time
    jogadoresEmbaralhados.forEach((jogador, index) => {
      if (novoTime1.length < qtdPorTime) {
        novoTime1.push(jogador);
      } else if (novoTime2.length < qtdPorTime) {
        novoTime2.push(jogador);
      }
    });

    // Atualiza os times no estado
    setTime1(novoTime1);
    setTime2(novoTime2);
    setOrdenacaoSelecionada("aleatoria");
  };

  const iniciarJogo = async () => {
    if (!ordenacaoSelecionada) {
      alert("Selecione o método de ordenação antes de iniciar o jogo!");
      return;
    }
    if (jogadores.length < minimoJogadores) {
      alert(
        `É necessário pelo menos ${
          minimoJogadores
        } jogadores para iniciar o jogo!`
      );
      return;
    }
    try {
      const jogadoresTime1 = [...time1];
      const jogadoresTime2 = [...time2];

      // Filtra os jogadores que não estão nem no Time 1 nem no Time 2 para definir as reservas
      const proxReservas = jogadores.filter(
        (jogador) =>
          !jogadoresTime1.some((t) => t.id === jogador.id) &&
          !jogadoresTime2.some((t) => t.id === jogador.id)
      );

      // Limpa os stores antes de salvar os novos dados
      await clearTime1();
      await clearTime2();
      await clearProxReservas();
      await clearGoleiros();

      // Limpa a chave 'partidas' do localStorage
      localStorage.removeItem("partidas");

      // Salva os novos jogadores individualmente em cada store
      await saveTime1(jogadoresTime1);
      await saveTime2(jogadoresTime2);
      await saveProxReservas(proxReservas);

      const nextRoute =
        jogo?.contexto === "turma"
          ? `/turmas/${jogo.turmaId}/jogos/${jogo.jogoTurmaId}/andamento`
          : "/novo-amistoso/jogo-em-andamento";
      navigate(nextRoute);
    } catch (error) {
      console.error("Erro ao iniciar o jogo:", error);
    }
  };

  return (
    <>
      <Header />

      <div className="body">
        <div className="center">
          <div className="body-content card pre-jogo-card">
            <div className="pre-jogo-header">
              <div>
                <p className="pre-jogo-context">
                  {jogo?.contexto === "turma"
                    ? `# ${jogo?.turmaNome || "Turma"}`
                    : "# Pré Jogo"}
                </p>
                <h1>Seleção de times</h1>
                <span className="pre-jogo-subtitle">
                  {jogadores.length > 0
                    ? `${jogadores.length} jogadores confirmados`
                    : "Carregando lista de jogadores..."}
                </span>
              </div>
              <div className="pre-jogo-summary">
                <div className="pre-jogo-summary-item">
                  <span>Jogadores por time</span>
                  <strong>{qtdPorTime}</strong>
                </div>
                <div className="pre-jogo-summary-item">
                  <span>Tempo de jogo</span>
                  <strong>
                    {jogo?.tempoDeJogo ? `${jogo.tempoDeJogo} min` : "Livre"}
                  </strong>
                </div>
                <div className="pre-jogo-summary-item">
                  <span>Pontos para acabar</span>
                  <strong>
                    {jogo?.pontosParaAcabar
                      ? `${jogo.pontosParaAcabar} pts`
                      : "Sem limite"}
                  </strong>
                </div>
              </div>
            </div>

            <section className="pre-jogo-section">
              <div className="pre-jogo-section-header">
                <div>
                  <p>Ordenação</p>
                  <h2>Como deseja montar os times?</h2>
                </div>
                <span className="pre-jogo-badge">
                  mínimo {minimoJogadores} jogadores
                </span>
              </div>
              <div className="pre-jogo-sort-options">
                <button
                  type="button"
                  onClick={criarTimesPorChegada}
                  className={`pre-jogo-sort-option ${
                    ordenacaoSelecionada === "chegada" ? "active" : ""
                  }`}
                >
                  <span className="pre-jogo-sort-title">Chegada</span>
                  <span className="pre-jogo-sort-description">
                    Monta alternando conforme a ordem de entrada dos jogadores.
                  </span>
                </button>
                <button
                  type="button"
                  onClick={criarTimesAleatorios}
                  className={`pre-jogo-sort-option ${
                    ordenacaoSelecionada === "aleatoria" ? "active" : ""
                  }`}
                >
                  <span className="pre-jogo-sort-title">Aleatória</span>
                  <span className="pre-jogo-sort-description">
                    Embaralha os jogadores e distribui de forma equilibrada.
                  </span>
                </button>
              </div>
            </section>

            <section className="pre-jogo-section pre-jogo-times-section">
              <div className="pre-jogo-section-header">
                <div>
                  <p>Times</p>
                  <h2>Pré-visualização</h2>
                </div>
                <span className="pre-jogo-badge">
                  {time1.length + time2.length}/{minimoJogadores} alocados
                </span>
              </div>
              <div className="pre-times-grid">
                <div className="pre-time-card">
                  <div className="pre-time-header">
                    <div className="pre-time-info">
                      <span
                        className="pre-time-color"
                        style={{ backgroundColor: jogo?.corTime1 || "#11998e" }}
                      />
                      <div>
                        <p>Time 1</p>
                        <strong>Capacidade {qtdPorTime}</strong>
                      </div>
                    </div>
                    <span className="pre-time-count">
                      {time1.length}/{qtdPorTime}
                    </span>
                  </div>
                  <div className="pre-time-list">
                    {time1.length > 0 ? (
                      time1.map((jogador) => (
                        <div key={jogador.id} className="pre-time-player">
                          <span
                            className="pre-time-player-avatar"
                            style={{
                              backgroundColor: jogo?.corTime1 || "#11998e",
                            }}
                          >
                            {getInicial(jogador.nome)}
                          </span>
                          <span>{jogador.nome}</span>
                        </div>
                      ))
                    ) : (
                      <span className="pre-time-empty">
                        Escolha uma ordenação para preencher este time.
                      </span>
                    )}
                  </div>
                </div>

                <div className="pre-time-card">
                  <div className="pre-time-header">
                    <div className="pre-time-info">
                      <span
                        className="pre-time-color"
                        style={{ backgroundColor: jogo?.corTime2 || "#38ef7d" }}
                      />
                      <div>
                        <p>Time 2</p>
                        <strong>Capacidade {qtdPorTime}</strong>
                      </div>
                    </div>
                    <span className="pre-time-count">
                      {time2.length}/{qtdPorTime}
                    </span>
                  </div>
                  <div className="pre-time-list">
                    {time2.length > 0 ? (
                      time2.map((jogador) => (
                        <div key={jogador.id} className="pre-time-player">
                          <span
                            className="pre-time-player-avatar"
                            style={{
                              backgroundColor: jogo?.corTime2 || "#38ef7d",
                            }}
                          >
                            {getInicial(jogador.nome)}
                          </span>
                          <span>{jogador.nome}</span>
                        </div>
                      ))
                    ) : (
                      <span className="pre-time-empty">
                        Escolha uma ordenação para preencher este time.
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </section>

            <section className="pre-jogo-section pre-jogo-jogadores-section">
              <div className="pre-jogo-section-header">
                <div>
                  <p>Jogadores</p>
                  <h2>Lista completa</h2>
                </div>
                <span className="pre-jogo-badge">
                  {jogadores.length} confirmados
                </span>
              </div>
              <div className="pre-jogadores-grid">
                {jogadores.length > 0 ? (
                  jogadores.map((jogador) => (
                    <div key={jogador.id} className="pre-jogador-chip">
                      <span className="pre-jogador-avatar">
                        {getInicial(jogador.nome)}
                      </span>
                      <div>
                        <strong>{jogador.nome}</strong>
                        <small>#{jogador.id ?? "--"}</small>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pre-jogadores-empty">
                    Nenhum jogador disponível ainda. Aguarde as confirmações.
                  </div>
                )}
              </div>
            </section>

            <button
              id="novo-jogo"
              className="btn-app pre-jogo-start"
              onClick={iniciarJogo}
              disabled={!prontoParaIniciar}
            >
              {prontoParaIniciar
                ? "Iniciar jogo"
                : "Selecione a ordenação para iniciar"}
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PreJogo;
